import { type PropsWithChildren, Suspense } from 'react';

import { BootError } from '@/console/host/boot-error';
import { BootLoading } from '@/console/host/boot-loading';
import { RenderErrorBoundary } from '@/shared/components/ui/render-error-boundary/render-error-boundary';

// Above both experiences, so a chunk that fails to load or a crash neither one catches
// still leaves the reader something to act on instead of a blank page.
export const BootBoundary = ({ children }: PropsWithChildren) => (
  <RenderErrorBoundary fallback={<BootError />}>
    <Suspense fallback={<BootLoading />}>{children}</Suspense>
  </RenderErrorBoundary>
);
